import { Button } from '@components/Button';
import EVImg from '@components/EVImg';
import Block from '@components/Layout/Block';
import { useTranslations } from 'next-intl';
import { FC } from 'react';
import { ContentContainer, GridContainer, Header, ImageBox, Text } from './styles';

export interface ShortProps {
  bodyText: string;
  ctaUrl?: string;
  ctaText?: string;
  header?: string;
  imgFocalPoint?: any;
}

const Short: FC<ShortProps> = ({ bodyText, ctaUrl, ctaText, header, imgFocalPoint }) => {
  const t = useTranslations();
  return (
    <Block squish fullOnMobile>
      <GridContainer>
        <ImageBox>
          <EVImg imageFocalPointData={imgFocalPoint} sizes={['90vw', '50vw', '33vw', '800px']} />
        </ImageBox>
        <ContentContainer>
          {header && <Header>{header}</Header>}
          <Text>{bodyText}</Text>
          {ctaUrl && (
            <Button
              variant="tertiary"
              label={ctaText ? ctaText : t('Learn More')}
              url={ctaUrl}
              arrow={true}
              arrowColor="black"
            />
          )}
        </ContentContainer>
      </GridContainer>
    </Block>
  );
};

export default Short;
